import { SmartLink } from '../../fragments/smart-link/SmartLink';
import Cta from '../../fragments/cta/Cta';
import LazyGravityForm from '../../fragments/gravity-form/LazyGravityForm';

import { useCallback, useContext, useEffect, useMemo } from 'react';
import {
  ThemeContext,
  useIsDesktop,
} from '../../context/ThemeContextManagement';

// import RecaptchaNotice from '../../fragments/recaptcha-notice/RecaptchaNotice';

import Row from './Row';
import QuakerLogo from './QuakerLogo';

import Row1 from './Row1';
import FooterHoverImage from './FooterHoverImage';

import { useRef } from 'react';
import {
  motion,
  useScroll,
  useTransform,
  easeIn,
  easeOut,
  useInView,
} from 'motion/react';

export default function NavigationFooter({ block, gravityForms }) {
  // console.log(block);
  const boxRef = useRef(null);
  const isInView = useInView(boxRef);

  const signupForm = block.gravityFormId
    ? gravityForms?.[block.gravityFormId]
    : null;

  const hoverImageRef = useRef(null);
  const isDesktop = useIsDesktop();
  const { touch } = useContext(ThemeContext);
  const hoverEnabled = isDesktop && !touch;

  const hoverImages = useMemo(
    () =>
      block.menu
        .slice(0, 3)
        .flatMap((col) =>
          (col.children || []).map((item) => item.featuredImage || null)
        ),
    [block.menu]
  );

  const handleLinkEnter = useCallback(
    (i) => hoverImageRef.current?.show(i),
    []
  );
  const handleNavLeave = useCallback(() => hoverImageRef.current?.hide(), []);

  // console.log(block);

  const { scrollYProgress } = useScroll({
    target: boxRef,
    offset: ['start end', 'start start'],
  });

  const yOffset = useTransform(
    scrollYProgress,
    [0, 1],
    [isDesktop ? -250 : -100, 0],
    {
      ease: easeOut,
    }
  );
  const opacity = useTransform(scrollYProgress, [0, 0.9], [0.4, 0]);

  // Map the yOffset to a transform string
  const transform = useTransform(
    yOffset,
    (value) => `translateY(${value}px) translateZ(0)`
  );

  // Add/remove class when footer is 50% in view
  useEffect(() => {
    const pageWrapper = document.querySelector('.pageWrapper');
    if (!pageWrapper) return;

    if (isInView) {
      pageWrapper.classList.add('footerInView');
    } else {
      pageWrapper.classList.remove('footerInView');
    }
  }, [isInView]);

  return (
    <footer className="mainFooter">
      <div
        name="NavigationFooter"
        className="NavigationFooter dark"
        ref={boxRef}
      >
        <motion.div
          style={{
            pointerEvents: 'none',
            zIndex: '1',
            position: 'absolute',
            inset: '0',
            backgroundColor: '#000000',
            opacity,
          }}
        ></motion.div>
        <motion.div
          style={{
            transform,
            willChange: 'transform',
          }}
        >
          <div className="l-grid">
            <hr className="l-grid__col NavigationFooter-hr" />
            <div className="l-grid__col l-grid__col--l-4-12 NavigationFooter-signupCol">
              <div style={{ position: 'relative' }}>
                <p className="h4">
                  Sign up to stay connected with our community
                </p>
                {signupForm?.gfForm && (
                  <LazyGravityForm
                    className="NavigationFooter-signupForm"
                    data={signupForm}
                  />
                )}
                <FooterHoverImage ref={hoverImageRef} images={hoverImages} />
              </div>
            </div>
            <div className="l-grid__col l-grid__col--l-push-3-12 l-grid__col--l-5-12">
              <Row1
                block={block}
                onLinkEnter={hoverEnabled ? handleLinkEnter : undefined}
                onNavLeave={hoverEnabled ? handleNavLeave : undefined}
              />
            </div>
            <div className="l-grid__col l-grid__col--l-4-12 NavigationFooter-locationCol">
              <hr className="mobile-only" />
              {block.locationHeading && (
                <p className="headingStrong NavigationFooter-locationHeading step--1">
                  {block.locationHeading}
                </p>
              )}
              {block.locationLink && (
                <Cta
                  className="NavigationFooter-locationLink"
                  theme="underline"
                  icon={false}
                  cta={{
                    url: block.locationLink.url,
                    buttonLabel: block.locationLink.title,
                  }}
                />
              )}
            </div>

            <div className="l-grid__col l-grid__col--l-push-3-12 l-grid__col--l-5-12">
              <hr className="mobile-only" />
              <QuakerLogo />
            </div>
            <hr className="l-grid__col" />
            <div className="l-grid__col">
              <Row block={block} />
            </div>
            {/* <SocialLinks block={block} /> */}
          </div>
        </motion.div>
      </div>
    </footer>
  );
}
